import React, { useMemo } from 'react';

import { useGetUsers } from '@vlabs/api/artemy/client';
import { PaginationPanel } from '@vlabs/uikit/components/pagination-v2';

import { useSearchUsersBy } from '@vlabs/monokit/features/point/search-users-by';

import { UserListTable } from './user-list-table/UserListTable';
import st from './UserListTableViewer.module.sass';
import { useUserListFilters } from '../../../entities/users/filters';

function UserListTableViewer(): React.JSX.Element {
  const searchUsersBy = useSearchUsersBy();
  const isSearchMode = searchUsersBy?.data !== undefined;
  const { filters, updateFilters } = useUserListFilters();

  const getUsers = useGetUsers(filters, { query: { enabled: !isSearchMode } });

  const usersData = useMemo(() => (
    searchUsersBy?.data ?? getUsers.data?.users ?? []
  ), [getUsers.data?.users, searchUsersBy?.data]);

  return (
    <React.Fragment>
      <UserListTable users={usersData} />
      {!isSearchMode && (
        <div className={st.Pagination}>
          <PaginationPanel
            canNextPage={(getUsers?.data?.users?.length ?? 0) >= (filters.page_size ?? 0)}
            canPreviousPage={(filters?.page ?? 0) > 0}
            gotoPage={(page) => updateFilters({ page: page + 1 })}
            nextPage={() => updateFilters({ page: (filters?.page ?? 0) + 1 })}
            pageCount={Math.ceil(((getUsers?.data?.users?.length ?? 0) / (filters?.page_size ?? 25)))}
            pageIndex={(filters?.page ?? 1) - 1}
            pageSize={filters.page_size}
            previousPage={() => updateFilters({ page: (filters?.page ?? 0) - 1 })}
            setPageSize={(page_size: number) => updateFilters({ page_size })}
          />
        </div>
      )}
    </React.Fragment>
  );
}

export { UserListTableViewer };
